<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage">
<div epub:type="pagebreak" id="pageiii" title="iii">
<p class="title"><a id="title"></a>The White Cockade</p>
<p class="subtitle">Historical Tales of the Jacobites</p>
<p class="aut1"><em>by</em></p>
<p class="aut">Stuart McHardy</p>
<p class="pub"><img alt="Illustration" src="images/pub.png"/></p>
</div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?73b8427a